module.exports = __webpack_public_path__ + "static/media/Danthabhagya2.dc3adf78.jpg";